import { RefObject } from "react"

import { ProfileQueryEmbeddedItemData } from "../../../repository/models";
import { convertFromIso } from "../../../components/SearchForm/searchform-helpers";
import { links } from "./variables";
import { CombinedProfileAndJsonSchema } from "../../../repository/models_v2";

export const calculateDraggablePane = ():{left?: number, top?: number, right?: number, bottom?: number} | string => {
  let leftBoundary = 0 - (window.outerWidth/2) + 320;
  let rightBoundary = (window.outerWidth/2) - 320;
  return {left: leftBoundary, right: rightBoundary};
}

export const getTitles = (rows: ProfileQueryEmbeddedItemData[]) => {
  if(!!rows[0]){
      const keys = Object.keys(rows[0])
      const keysWithoutLinks = keys.filter(item => item !== links)
      return keysWithoutLinks;
      // return keysWithoutLinks.filter(item => !item.startsWith(fileHiddenLabel) || item === fileNameLabel)
  }
  return []
}

export const getColumns = (rows: ProfileQueryEmbeddedItemData[], data: CombinedProfileAndJsonSchema|null) => {
  if(data !== null && data.jsonschema !== null){
    const titles = getTitles(rows)

    return titles.map(item => {
      if(item === 'jaar_opgave_jaar'){
        return createColumn(item, 'Jaar opgave jaar')
      }
      if(item === 'content'){ // TODO: [RGFNLSLA-860] needs fixing
        return createColumn(item, 'Content filename')
      }
      const label = data.jsonschema.properties[item]?.title

      return createColumn(item, label)
    })
  }
  const titles = getTitles(rows)

  return titles.map(item => createColumn(item))
}

export const createColumn = (value: string, label?: string) => {
  const labelWithoutUnderscore = value?.replaceAll('_', ' ')
  const updatedLabel = labelWithoutUnderscore.charAt(0).toUpperCase() + labelWithoutUnderscore.slice(1);
  return ({
      name: value,
      label: !!label ? label : updatedLabel,
      options: {
          filter: true,
          sort: true,
          display: value !== 'id',
          customBodyRender: (value) => {
              if (typeof value === 'object' && value !== null) {
                  if (Object.hasOwn(value, "filename") && Object.hasOwn(value, "length") && Object.hasOwn(value, "mimetype")) {
                      return value.filename === null ? "< Filename niet beschikbaar >" : value.filename;
                  }
                  console.warn("Table received complex object when expecting simple value.", value)
                  return JSON.stringify(value);
              }
              return value;
          }
      }
  })
}

export const updateRowDates = (rows: ProfileQueryEmbeddedItemData[]) => {
  return rows.map(row => {
    const entries = Object.entries(row)
    const newEntries = entries.map(([key, value]) => {
      if(typeof value === 'string'){
        
        if(isIsoDate(value.trim())){
          return { [key]: convertFromIso(value.trim()) }
        }

        const list = value.trim().split(' ')
        if(!!list.find(item => isIsoDate(item.trim()))){
          const newList = list.map(item => {
            if(isIsoDate(item.trim())){
              return convertFromIso(item.trim())
            }
            return item
          })
          return { [key]: newList.join(' ● ') }
        }

        return { [key]: value }
      }

      return { [key]: value }
    })

    const newValue: { [k: string]: any } = {}
    newEntries.forEach((item) => {
      const [key, value] = Object.entries(item)[0]
      newValue[key] = value
    })

    return newValue
  })
}

const isIsoDate = (str: string) => {
  if(!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str) && !/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z/.test(str)){
    return false
  }
  
  const d = new Date(str)
  return d instanceof Date && !isNaN(Number(d)); // valid date 
}

export const getTableColumnSizes = (
    rightColumnRef: RefObject<HTMLDivElement>,
    leftColumnRef: RefObject<HTMLDivElement>,
    openedViewer: boolean,
    urlPresent: boolean,
    dividerLocation: number
) => {
    const leftWidth = ((dividerLocation/window.outerWidth) * 100) -1;
    const rightWidth = (((window.outerWidth - dividerLocation)/window.outerWidth) * 100) - 1;

    if(!!leftColumnRef?.current){
        leftColumnRef.current.style.width = urlPresent ? `${leftWidth}%` : '100%'
    }

    if(!!rightColumnRef?.current){
        const page = rightColumnRef.current?.querySelector<HTMLElement>('.rpv-core__inner-page')
        rightColumnRef.current.style.height = !!page ? `${page?.offsetHeight+64}px` : '100%'

        if(!openedViewer){
            rightColumnRef.current.style.width = '0%'
            return 
        }

        if(urlPresent){
            rightColumnRef.current.style.width = `${rightWidth}%`
        }
    }
}
